export const addTableFilter = (name, filter) => ({
    type: "TABLE_FILTER_ADD",
    name,
    filter
});